// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 0TfuTAaJ9ep
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Checkbox3 from "../../Checkbox3"; // plasmic-import: YObM5SxsQhe/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingOwnerDetailsDocument.module.css"; // plasmic-import: 0TfuTAaJ9ep/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingOwnerDetailsDocument__VariantProps = new Array();

export const PlasmicOnboardingOwnerDetailsDocument__ArgProps = new Array(
  "titleSlot",
  "subtitleSlot"
);

const $$ = {};

function PlasmicOnboardingOwnerDetailsDocument__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "licenseCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "idCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__sRMsy)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ijMdG
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___95Gwg)}>
            <div className={classNames(projectcss.all, sty.freeBox__lhInE)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__nVFoU)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gfT9L)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__fdj68)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__iQze)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__be4HI)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__oYzDn)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__koZb)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__lEKyl)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__dErmc)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__z30LG)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ihIff)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hShj)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__l2JnK)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___1F9Hg
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__d90Rv
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tTVmE
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__afhoR
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___7V9O6
                )}
              >
                {"Retry & Submit"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__dbWYe)}>
                {p.renderPlasmicSlot({
                  defaultContents:
                    "Our compliance partners have requested additional documentation in order to verify the identity of your owner Sean O'Brien.",
                  value: args.titleSlot,
                  className: classNames(sty.slotTargetTitleSlot)
                })}
              </div>
              <div
                data-plasmic-name={"controllerStack"}
                data-plasmic-override={overrides.controllerStack}
                className={classNames(projectcss.all, sty.controllerStack)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__ch0NM)}>
                  {p.renderPlasmicSlot({
                    defaultContents:
                      "Please upload a driver's license or government-issued ID card in order to verify Sean O'Brien's identity. The uploaded file must be either a .jpg, .jpeg, or .png, and be no larger than 10MB in size. ",
                    value: args.subtitleSlot,
                    className: classNames(sty.slotTargetSubtitleSlot)
                  })}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___95LIo
                  )}
                >
                  {"Document Type"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__vuXpe)}>
                  <Checkbox3
                    data-plasmic-name={"licenseCheck"}
                    data-plasmic-override={overrides.licenseCheck}
                    className={classNames("__wab_instance", sty.licenseCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "licenseCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "licenseCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title9"}
                    data-plasmic-override={overrides.title9}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title9
                    )}
                  >
                    {"Driver's License (state issued)"}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__ec5Nu)}>
                  <Checkbox3
                    data-plasmic-name={"idCheck"}
                    data-plasmic-override={overrides.idCheck}
                    className={classNames("__wab_instance", sty.idCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "idCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "idCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title11"}
                    data-plasmic-override={overrides.title11}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title11
                    )}
                  >
                    {"ID Card (government-issued photo ID) "}
                  </div>
                </div>
                <div
                  data-plasmic-name={"errorText"}
                  data-plasmic-override={overrides.errorText}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.errorText
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Must complete all required fields"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  data-plasmic-name={"contentError"}
                  data-plasmic-override={overrides.contentError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.contentError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Invalid File Type: The uploaded file must be either a .jpg, .jpeg, or .png. "
                        }
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {
                          "Invalid File Type: The uploaded file must be either a .jpg, .jpeg, or .png. "
                        }
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  data-plasmic-name={"submitButton"}
                  data-plasmic-override={overrides.submitButton}
                  className={classNames(projectcss.all, sty.submitButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cvkgP
                    )}
                  >
                    {"Upload & Submit"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "vertStack",
    "controllerStack",
    "licenseCheck",
    "title9",
    "idCheck",
    "title11",
    "errorText",
    "contentError",
    "submitButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  vertStack: [
    "vertStack",
    "controllerStack",
    "licenseCheck",
    "title9",
    "idCheck",
    "title11",
    "errorText",
    "contentError",
    "submitButton"
  ],

  controllerStack: [
    "controllerStack",
    "licenseCheck",
    "title9",
    "idCheck",
    "title11",
    "errorText",
    "contentError",
    "submitButton"
  ],

  licenseCheck: ["licenseCheck"],
  title9: ["title9"],
  idCheck: ["idCheck"],
  title11: ["title11"],
  errorText: ["errorText"],
  contentError: ["contentError"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingOwnerDetailsDocument__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingOwnerDetailsDocument__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingOwnerDetailsDocument__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingOwnerDetailsDocument";
  } else {
    func.displayName = `PlasmicOnboardingOwnerDetailsDocument.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingOwnerDetailsDocument = Object.assign(
  // Top-level PlasmicOnboardingOwnerDetailsDocument renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    vertStack: makeNodeComponent("vertStack"),
    controllerStack: makeNodeComponent("controllerStack"),
    licenseCheck: makeNodeComponent("licenseCheck"),
    title9: makeNodeComponent("title9"),
    idCheck: makeNodeComponent("idCheck"),
    title11: makeNodeComponent("title11"),
    errorText: makeNodeComponent("errorText"),
    contentError: makeNodeComponent("contentError"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicOnboardingOwnerDetailsDocument
    internalVariantProps: PlasmicOnboardingOwnerDetailsDocument__VariantProps,
    internalArgProps: PlasmicOnboardingOwnerDetailsDocument__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingOwnerDetailsDocument;
/* prettier-ignore-end */
